// Auto-generated by scripts/generate-version.js at build time. Do not edit.
export const APP_VERSION = 'cdb77ae-1793181083219'
